import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [booted, setBooted] = useState(false);
  const [org, setOrg] = useState(null);
  const [locked, setLocked] = useState(false);

  const loadOrg = useCallback(async () => {
    try {
      const { data } = await api.get("/org/me");
      setOrg(data);
      setLocked(!!data.locked);
    } catch { /* kurum bilgisi alınamadı */ }
  }, []);

  const load = useCallback(async () => {
    const t = localStorage.getItem("ktt_token");
    if (!t) { setUser(false); setBooted(true); return; }
    // Geçici (ağ/5xx) hatalarda kullanıcıyı login'e ATMAMAK için son bilinen kullanıcıyı önce göster
    const cached = localStorage.getItem("ktt_user");
    if (cached) { try { setUser(JSON.parse(cached)); } catch { /* yoksay */ } }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("ktt_user", JSON.stringify(data));
      await loadOrg();
    } catch (e) {
      const st = e?.response?.status;
      if (st === 401 || st === 403) {
        // Token gerçekten geçersiz/süresi dolmuş → çıkış
        localStorage.removeItem("ktt_token");
        localStorage.removeItem("ktt_user");
        setUser(false);
      } else if (!cached) {
        // Geçici hata ve elde önbellek yok → oturumu silme, login'e atma; yüklenmeyi sürdür
        setUser(false);
      }
      // Geçici hata + önbellek var → oturum KORUNUR (kullanıcı atılmaz)
    }
    setBooted(true);
  }, [loadOrg]);

  useEffect(() => { load(); }, [load]);

  // API 402 → kurum kilitli
  useEffect(() => {
    const h = () => { setLocked(true); loadOrg(); };
    window.addEventListener("ktt-locked", h);
    return () => window.removeEventListener("ktt-locked", h);
  }, [loadOrg]);

  const setSession = (token, u) => {
    localStorage.setItem("ktt_token", token);
    if (u) localStorage.setItem("ktt_user", JSON.stringify(u));
    setUser(u);
    setLocked(false);
    loadOrg();
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setSession(data.access_token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("ktt_token");
    localStorage.removeItem("ktt_user");
    setUser(false);
    setOrg(null);
    setLocked(false);
  };

  return (
    <AuthContext.Provider value={{ user, booted, org, locked, login, logout, setSession, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}
